import { parse } from './parser';
import { map } from './mapper';
import { unmap } from './unmapper';

function getStackFrames(error) {
  var unhandledRejection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var contextSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;

  var parsedFrames = parse(error);
  var enhancedFramesPromise = void 0;

  if (error.__unmap_source) {
    enhancedFramesPromise = unmap(error.__unmap_source, parsedFrames, contextSize);
  } else {
    enhancedFramesPromise = map(parsedFrames, contextSize);
  }

  return enhancedFramesPromise.then(function (enhancedFrames) {
    var isDevelopment = process.env.NODE_ENV !== 'production';

    if (isDevelopment) {
      if (enhancedFrames.map(function (f) {
        return f._originalFileName;
      }).filter(function (f) {
        return f != null && f.indexOf('node_modules') === -1;
      }).length === 0) {
        return null;
      }
    }

    return enhancedFrames.filter(function (_ref) {
      var functionName = _ref.functionName;
      return functionName == null || functionName.indexOf('__stack_frame_overlay_proxy_console__') === -1;
    });
  });
}

export default getStackFrames;
export { getStackFrames };